module.exports = __webpack_public_path__ + "img/indiase-curry-met-tofu.6e819d5d.jpg";